import axios from 'axios';
import { getUserFromLS } from '../../utils/getUserFromLS';
import { ICalendarContactIntelligence } from '../../Types/calendar';
import { getTutorialContactIntelligence } from '../tutorialFixtureResponses';

export const getContactIntelligence = (
  contactId: string,
  callback: (response: ICalendarContactIntelligence) => void,
  errorCallback: (error: any) => void
) => {
  const fixture = getTutorialContactIntelligence(contactId);
  if (fixture) {
    if (callback != null) {
      callback(fixture as ICalendarContactIntelligence);
    }
    return Promise.resolve(fixture);
  }

  const user = getUserFromLS();
  const URL = `${import.meta.env.VITE_API_BASE_URL}/contact_intelligence/${contactId}`;

  return axios(URL, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${user.access_token}`
    }
  })
    .then((response) => {
      if (callback != null) {
        callback(response.data as ICalendarContactIntelligence);
      }
    })
    .catch((error) => {
      console.error('Error fetching contact intelligence:', error);
      if (errorCallback != null) {
        errorCallback(error);
      }
    });
};
